<template>
  <VDataGridV2
        :data="documents"
        layout="fill"
        group-children-property="positions"
    >
      <!-- Верхний уровень: вложенная ЗТК -->
      <VDataGridGroupV2>
        <template #default="{ parent }">
          <VLink @click.stop="TransportOrdersService.showTransportOrderDialog(parent.id)">
            ЗТК №{{ Utils.string.formatWithDelimiter(parent.id) }}
          </VLink>
          Откуда: {{ parent.senderStore?.transportZone?.name || '--' }}
          Куда: {{ parent.receiverStore?.transportZone?.name || '--' }}
          |
          Температурный режим: {{ parent.storeTemperatureRange.toString({unit: '°C'}) || 'не задан' }}

          <VButton
            material="delete"
            :disabled="transportOrder.getReasonCannotDeletePosition() !== null"
            :title="transportOrder.getReasonCannotDeletePosition() ?? undefined"
            @click="deleteDocument(parent)"
          />
        </template>
      </VDataGridGroupV2>

      <VDataGridColumnV2 id="id" label="№" width="80px">
        <template #default="{ row }">
          <VLink @click="openDocumentDialog(row)">
            {{ Utils.string.formatWithDelimiter(row.document?.id) }}
          </VLink>
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2 id="documentClass" label="Тип" width="100px">
        <template #default="{ row }">
          {{ row.document.entityTypeName }}
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2 id="sender" label="От кого" width="180px">
        <template #default="{ row }">
          {{ row.document?.sender?.name || row.document?.seller?.name || '--' }}
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2 id="receiver" label="Кому" width="180px">
        <template #default="{ row }">
          {{ row.document?.receiver?.name || row.document?.buyer?.name || '--' }}
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2 id="senderStore" label="Откуда" content-class="ellipsis" width="150px">
        <template #default="{ row }">
          <span
            :title="row.document?.sellerStore.address"
          >
            {{ row.document?.sellerStore.address || '--' }}
          </span>
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2 id="receiverStore" label="Куда" content-class="ellipsis" width="150px">
        <template #default="{ row }">
          <span
            :title="row.document?.buyerStore.address"
          >
            {{ row.document?.buyerStore.address || '--' }}
          </span>
        </template>
      </VDataGridColumnV2>

      <VDataGridActionBarV2 class="centered">
        <VLink @click="openPicker" material="add"> Добавить ЗТК </VLink>
      </VDataGridActionBarV2>
  </VDataGridV2>
</template>

<script lang="ts">
import Utils                        from '@/core/utils/Utils';
import TransportOrder               from '@/domains/TransportOrders/TransportOrder';
import TransportOrderPosition       from '@/domains/TransportOrders/TransportOrderPosition';
import TransportOrdersService       from "@/domains/TransportOrders/TransportOrdersService";
import TransportableDocumentsService
  from "@/domains/TransportableDocuments/TransportableDocumentsService";

export default defineComponent({
  name: 'TransportOrdersGrid',

  props: {
    transportOrder: {
      type:     TransportOrder,
      required: true,
    },
  },

  data() {
    return {
      TransportOrdersService,
      Utils,
    };
  },

  computed: {
    documents(): TransportOrder[] {
      return this.transportOrder.positions
          .filter((transportOrderPosition: TransportOrderPosition) => transportOrderPosition.documentClass === 'TransportOrder')
          .map((transportOrderPosition: TransportOrderPosition) => transportOrderPosition.document) as TransportOrder[];
    },
  },

  methods: {
    deleteDocument(document: TransportOrder): void {
      const position = this.transportOrder.positions.find((transportOrderPosition: TransportOrderPosition) =>
            transportOrderPosition.documentClass === 'TransportOrder' && transportOrderPosition.document?.id === document.id,
      );
      if (!position) return;

      this.transportOrder.deletePosition(position);
    },

    openPicker(): void {
      // тип документа передаётся в пикер пропом, не через localStorage
      this.$core.dialogs.TransportableDocumentsPicker.show({
        transportOrder: this.transportOrder,
        documentClass:  ['TransportOrder'],
      });
    },

    openDocumentDialog(row: TransportOrderPosition): void {
      TransportableDocumentsService[row.documentClass].showDialog(row.document)
    },
  },
});
</script>
